(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const bullet = event.target.closest('.collection-filter-bullet');
    if (!bullet) return;

    const inputs = document.querySelectorAll('facets-form-component input[type="checkbox"]');
    const input =
      [...inputs].find(
        (candidate) =>
          candidate.name === bullet.dataset.filterName &&
          candidate.value === bullet.dataset.filterValue &&
          !candidate.closest('dialog')
      ) ||
      [...inputs].find(
        (candidate) =>
          candidate.name === bullet.dataset.filterName && candidate.value === bullet.dataset.filterValue
      );

    if (input) input.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-video-popup')) {
    customElements.define('testimonial-video-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('dialog');
        this.feed = this.querySelector('.testimonial-popup__feed');
        this.items = [...this.feed.querySelectorAll('.testimonial-popup__item')];
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-video-index].testimonials-slider__open');
          if (trigger) {
            event.preventDefault();
            event.stopPropagation();
            this.open(trigger);
          }
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('[data-close]')) {
            this.dialog.close();
            return;
          }
          const video = this.active?.querySelector('video');
          if (!video) return;
          if (event.target.closest('[data-mute]')) video.muted = !video.muted;
          if (event.target.closest('[data-play]') || event.target === video) {
            if (video.paused) this.play(video);
            else video.pause();
          }
          this.update(video);
        }, options);
        this.dialog.addEventListener('close', () => this.cleanup(), options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dialog.close();
        }, options);
        this.observer = new IntersectionObserver((entries) => {
          if (!this.dialog.open) return;
          const visible = entries.filter(entry => entry.intersectionRatio > 0.5)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) this.activate(visible.target);
        }, { root: this.feed, threshold: [0, 0.5, 0.75, 1] });
      }
      play(video) {
        const promise = video.play();
        if (promise) promise.then(() => this.update(video), () => {
          this.setLoading(video.closest('.testimonial-popup__item'), false);
          this.update(video);
        });
      }
      setLoading(item, loading) {
        item.querySelector('.testimonial-popup__loader').hidden = !loading;
        item.setAttribute('aria-busy', String(loading));
      }
      updateProgress(video) {
        const progress = video.closest('.testimonial-popup__item').querySelector('.testimonial-popup__progress');
        progress.value = Number.isFinite(video.duration) && video.duration > 0
          ? Math.min(100, Math.max(0, video.currentTime / video.duration * 100))
          : 0;
      }
      update(video) {
        const item = video.closest('.testimonial-popup__item');
        item.querySelector('[data-play]').setAttribute('aria-label', video.paused ? 'Play' : 'Pause');
        item.querySelector('[data-mute]').setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        item.querySelector('[data-icon="play"]').toggleAttribute('hidden', !video.paused);
        item.querySelector('[data-icon="pause"]').toggleAttribute('hidden', video.paused);
        item.querySelector('[data-icon="muted"]').toggleAttribute('hidden', !video.muted);
        item.querySelector('[data-icon="unmuted"]').toggleAttribute('hidden', video.muted);
      }
      activate(item) {
        if (!this.dialog.open || this.active === item) return;
        this.items.forEach(other => {
          this.setLoading(other, false);
          other.querySelector('.testimonial-popup__controls').inert = other !== item;
          const video = other.querySelector('video');
          if (video) { video.pause(); video.autoplay = false; }
        });
        this.active = item;
        this.setLoading(item, true);
        let video = item.querySelector('video');
        if (!video) {
          item.prepend(item.querySelector('template').content.cloneNode(true));
          video = item.querySelector('video');
          ['timeupdate', 'loadedmetadata', 'durationchange', 'emptied', 'ended'].forEach(name => video.addEventListener(name, () => this.updateProgress(video), { signal: this.abort.signal }));
          ['play', 'pause', 'volumechange'].forEach(name => video.addEventListener(name, () => this.update(video), { signal: this.abort.signal }));
          ['loadstart', 'waiting', 'stalled'].forEach(name => video.addEventListener(name, () => {
            if (this.dialog.open && this.active === item && video.readyState < 3) this.setLoading(item, true);
          }, { signal: this.abort.signal }));
          ['canplay', 'playing', 'error', 'pause'].forEach(name => video.addEventListener(name, () => this.setLoading(item, false), { signal: this.abort.signal }));
        }
        this.setLoading(item, video.readyState < 3);
        video.muted = true;
        video.autoplay = true;
        this.updateProgress(video);
        this.update(video);
        this.play(video);
      }
      open(trigger) {
        const item = this.items.find(item => item.dataset.videoIndex === trigger.dataset.videoIndex);
        if (!item || this.dialog.open) return;
        document.querySelectorAll('testimonial-video-popup').forEach(other => {
          if (other !== this && other.dialog?.open) other.dialog.close();
          if (other !== this && other.lock) other.cleanup();
        });
        this.returnFocus = trigger;
        this.dialog.showModal();
        const body = document.body;
        this.lock = { x: window.scrollX, y: window.scrollY, styles: ['position', 'top', 'left', 'width', 'overflow'].map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]) };
        body.style.position = 'fixed';
        body.style.top = `-${this.lock.y}px`;
        body.style.left = `-${this.lock.x}px`;
        body.style.width = '100%';
        body.style.overflow = 'hidden';
        this.feed.scrollTop = item.offsetTop;
        this.activate(item);
        this.items.forEach(item => this.observer.observe(item));
        this.dialog.querySelector('[data-close]').focus({ preventScroll: true });
      }
      cleanup() {
        this.observer?.disconnect();
        this.items.forEach(item => {
          this.setLoading(item, false);
          const video = item.querySelector('video');
          if (video) { video.pause(); video.autoplay = false; video.muted = true; }
          item.querySelector('.testimonial-popup__controls').inert = true;
        });
        this.active = null;
        if (!this.lock) return;
        const { x, y, styles } = this.lock;
        styles.forEach(([name, value, priority]) => {
          if (value) document.body.style.setProperty(name, value, priority);
          else document.body.style.removeProperty(name);
        });
        this.lock = null;
        window.scrollTo({ left: x, top: y, behavior: 'instant' });
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.dialog?.close();
        this.cleanup();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
